/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { MThumbnails } from './thumbnails.js';

export let MCUnknown = function($,mj) {

	var media_class = 0;	// NO FULL SUPPORT FOR IE7 ANYMORE...: ... '<span class="ie7fix"></span>';

	function extractMediaBoxFromMetadata( mvarr, pageno, box ) {
		for( var i=0; i<mvarr.length; ++i ) {
			var lns = mvarr[i].split('\n');
			if( lns.length && parseInt(lns[0],10)==pageno ) {
				for( var l=1; l<lns.length; ++l ) {
					var vs = lns[l].split(' ');
					if( vs.length && vs[0]==box ) {
						return vs.slice(1); // = [ llx, lly, urx, ury, rotation ]
					}
				}
			}
		}
		return null;
	}

	return {
		init() {
		},
		createThumbnailDimAttrs: function( meta, iw, ih, up_scale ) {
			if( !meta ) return '';
			var meta_id_w = 200;	// use image dimensions
			if( meta[10] && meta[10][0]>0 ) meta_id_w = 10; // use custom preview dimensions
			var t;
			var src_w = meta[meta_id_w  ] ? meta[meta_id_w  ][0] : 0;
			var src_h = meta[meta_id_w+1] ? meta[meta_id_w+1][0] : 0;
			var dsp_rot = meta_id_w===200 ? ( meta[229] ? parseInt(meta[229][0],10) : 0 ) : 0;
			var dim = null;
			if( src_w>0 && src_h>0 ) {
				if( dsp_rot===90 || dsp_rot===270 ) {
					// swap width & height
					t = src_w;
					src_w = src_h;
					src_h = t;
				}
				dim = MThumbnails.getImageDimsScaledToBox(iw,ih,src_w,src_h,up_scale);
			} else if( meta_id_w===200 && meta[230] && meta[230][0]>0 ) {
				// text & vector files
				// usually the "rotated" aspect ratio is available
				var src_aspect = meta[230] ? meta[230][0] : 1;
				// however, if we have media boxes, then aspect ratio must be determined by box spec, pageno and display rotation
				if( meta[237] && meta[237][0] ) {
					// media boxes used -> compute actual aspect ratio from box specification
					var cur_box = meta[238] && meta[238][0] ? meta[238][0] : 'MediaBox';
					// var pageno = 1; // TODO: make it parameter
					var bxi = extractMediaBoxFromMetadata( meta[237], 1, cur_box );
					if( bxi!==null ) {
						var src_aspect_w = Math.abs(bxi[0]-bxi[2]);
						var src_aspect_h = Math.abs(bxi[1]-bxi[3]);
						dsp_rot += parseInt(bxi[4],10);
						if( dsp_rot===90 || dsp_rot===270 ) {
							t = src_aspect_w;
							src_aspect_w = src_aspect_h;
							src_aspect_h = t;
						}
						src_aspect = src_aspect_h / src_aspect_w;
					}
				}
				// -> compute dims from aspect ratio
				dim = MThumbnails.getDimsScaledToBoxByAspectRatio(iw,ih,src_aspect);
			} else {
				// for anything else -> compute dims from a 2:1 aspect ratio
				//???//dim = MThumbnails.getDimsScaledToBoxByAspectRatio(iw,ih,2.0);
				//dim = MThumbnails.getImageDimsScaledToBox(iw,ih,0.5*iw,0.5*ih,up_scale);
			}
			if( dim!==null ) return 'width="'+dim[0]+'" height="'+dim[1]+'"';
			//return 'style="min-width:'+dim[0]+'px; min-height:'+dim[1]+'px" width="'+dim[0]+'" height="'+dim[1]+'"';
			// any other case: just dont provide width & height to img tag
			return '';
		},
		createThumbnailCommon: function( media_class, media_id, meta, target, iw, ih, version, on_load_cb ) {
			//$(target).stop(true).off('mouseenter mouseleave');
			if( meta && meta[10] && meta[10][0] > 0 ) {
				// use custom preview (currently supports only cp_id==0)
				var mc = meta[-1] ? meta[-1][0] : media_class;
				var vq = version ? '&v='+encodeURIComponent(version) : '';
				var xattrs = MCUnknown.createThumbnailDimAttrs(meta,iw,ih,false);
				MThumbnails.createResponsiveImgElem(
					target,
					mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+mc+'_0_{iw}_{ih}.png?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq,
					{iw:iw,ih:ih},
					true,
					xattrs,
					null,
					on_load_cb
				);
				return true;
			}
			return false;
		},
		createThumbnail: function( media_id, meta, target, iw, ih, version, on_load_cb ) {
			if( MCUnknown.createThumbnailCommon(media_class,media_id,meta,target,iw,ih,version,on_load_cb) ) return;
			// thumbnail (should show an icon / error image)
			var mc = meta[-1] ? meta[-1][0] : media_class;
			var vq = version ? '&v='+encodeURIComponent(version) : '';
			var xattrs = MCUnknown.createThumbnailDimAttrs(meta,iw,ih,false);
			MThumbnails.createResponsiveImgElem(
				target,
				mj.webroot+'media/file/thumb/id/'+media_id+'_'+mc+'_{iw}_{ih}.png?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq,
				{iw:iw,ih:ih},
				true,
				xattrs,
				null,
				on_load_cb
			);
		},
		createPreview: function( dtinfo, target, xopts ) {
			var md_trg = $(target),
				media_id = dtinfo.media_id,
				meta = dtinfo.meta,
				mc = meta[-1] ? meta[-1][0] : media_class,
				vq = !dtinfo.is_latest_version ? '&v='+encodeURIComponent(dtinfo.version) : '';

			function resize_handler(e,w,h) {
				var md_view_w = Math.max(10,w-10),
					md_view_h = Math.max(10,h-10);
				if( meta[10] && meta[10][0] > 0 ) {
					// use custom preview (cp_id=0 only)
					md_trg.children('.md-empty-canvas')
						.css( {
							background:	'transparent url('+mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+mc+'_0_'+md_view_w+'_'+md_view_h+'.png?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+') center center no-repeat',
							width: md_view_w+'px',
							height: md_view_h+'px',
						} );

					// TODO: add responsive image css background

				} else {
					// thumbnail (should show an icon / error image)
					var iw = Math.min(md_view_w,240), ih = Math.min(md_view_h,240);
					md_trg.children('.md-empty-canvas')
						.css( {
							background:	'transparent url('+mj.webroot+'media/file/thumb/id/'+media_id+'_'+mc+'_'+iw+'_'+ih+'.png?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+') center center no-repeat',
							width: md_view_w+'px',
							height: md_view_h+'px',
						} );

					// TODO: add responsive image css background

				}
			}
			md_trg
				.off('.MCUnknown')
				.html('<div class="md-empty-canvas"></div>')
				.on('mjsresize.MCUnknown',resize_handler);
			resize_handler(null,md_trg.width(),md_trg.height());
		},
	};
}(jQuery,mj);
